import ProblemsBlock from "@components/ProblemsBlock";
import styles from "./styles.module.scss";
import { SpiderService } from "@services/spider/spider.services";
import { useEffect, useState } from "react";
import { Problem } from "src/store/insights/types";
import { useProductStore } from "src/store/overviewProduct.state";

const Overview = () => {
  const [selectedProblem, setSelectedProblem] = useState<Problem | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [spiderDots, setSpiderDots] = useState([]);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isDragEnabled, setIsDragEnabled] = useState(false);
  const [activeProblemIndex, setActiveProblemIndex] = useState(0);
  const [problems, setProblems] = useState([]);
  const { selectedProduct } = useProductStore();

  const handlePredictionInsightClick = () => {
    if (!isDragEnabled) {
      setIsTooltipVisible(true);
    } else {
      setIsTooltipVisible(false);
    }
    setIsDragEnabled(!isDragEnabled);
  };
  const handleProductSelect = async () => {
    const spider = new SpiderService();
    const spiderDotsResponse = await spider.getProfuctInfo(selectedProduct);

    setSpiderDots(Array.isArray(spiderDotsResponse) ? spiderDotsResponse : []);
    setProblems(Array.isArray(spiderDotsResponse) ? spiderDotsResponse : []);
  };

  useEffect(() => {
    handleProductSelect();
  }, []);

  return (
    <div className={styles.overviewWrapper}>
      <ProblemsBlock intelligence={true} />
    </div>
  );
};

export default Overview;
